import { combineReducers } from "redux";
import myCandidatesManagement from "../Components/MyCandidates/redux/reducer";
import settingsManagement from "../Components/Settings/redux/reducer";
import appManagement from "../Components/redux/reducer";
import userManagement from "../Components/user-redux/reducer";
import companiesManagement from "../Components/Companies/redux/reducer";
import loadingReducer from "./loadingReducer";
import resumeBuilderReducer from "../Components/OptimiseResume/ResumeBuilderActions/reducer";

const reducers = combineReducers({
  appManagement,
  userManagement,
  companiesManagement,
  myCandidatesManagement,
  settingsManagement,
  loading: loadingReducer,
  resumeBuilderReducer,
});

export default reducers;
